import styled from "@emotion/styled";
import { Label } from "react-aria-components";

export const StyledLabel = styled(Label)(props => ({
  fontSize: props.theme.fontSizes["paragraph-sm"],
  color: props.theme.colors.text.primary,
}));
